import { render } from "preact";
import { App } from "./components/App.tsx";

render(<App />, document.getElementById("root")!);
